import { memo } from 'react';

const LoadingTable = memo(() => {
    const rows = [];
    for (let index = 0; index < 5; index++) {
        rows.push(
            <tr key={index}>
                <td className="td-1"><span></span></td>
                <td className="td-2"><span></span></td>
                <td className="td-3"><span></span></td>
            </tr>
        );
    }
    return rows;
});

export default LoadingTable;